import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { ResponsiveImageUrls } from '@/types';
import { ModalName, useToggleModalsContext } from '@/common/contexts/globalModalContext';
import ResponsiveImage from '@/common/components/ResponsiveImage/ResponsiveImage';
import Button from '@/common/components/Button/Button';
import useVisibility from '@/pages/MarketReportsPreviewPage/components/Banner/useVisibility';
import grid from '@/common/css/grid.module.scss';
import styles from './Banner.module.scss';

interface BannerProps {
  title: string;
  marketReportLabel: string;
  imageUrls?: ResponsiveImageUrls;
  downloadButton: {
    text: string;
  };
}

const Banner: FC<BannerProps> = ({
  title,
  marketReportLabel,
  imageUrls,
  downloadButton,
}) => {
  const toggleModal = useToggleModalsContext();

  const showModal = useCallback((): void => {
    toggleModal({ [ModalName.marketReport]: true });
  }, [toggleModal]);

  const isVisible = useVisibility();

  return (
    <div className={classNames(grid.container, styles.container, !isVisible && styles.containerHidden)}>
      {!!imageUrls && (
        <div className={styles.imageWrapper}>
          <ResponsiveImage alt={title} urls={imageUrls} />
        </div>
      )}
      <div className={styles.title}>
        {`${title} ${marketReportLabel?.toLowerCase()}`}
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          customClassNames={{ button: styles.button }}
          onClick={showModal}
          text={downloadButton.text}
        />
      </div>
    </div>
  );
};

export default Banner;
